import { Dynamic } from './Dynamic';

export const HeaderDynamic = () => <Dynamic componentKey="Header" />;
